module.exports = __webpack_public_path__ + "static/media/map_marker.1a27590f.png";